import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";
import {
  TermsAndPrivacyParams,
  RespTermsAndPrivacyModel,
  TermsAndPrivacyResultInterface,
} from "./TermsAndPrivacy.models";

const terms = async (
  params: TermsAndPrivacyParams
): Promise<TermsAndPrivacyResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/terms/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const termsAndPrivacyResp = res as RespTermsAndPrivacyModel;
      const termsAndPrivacy = setTermsAndPrivacyModel(termsAndPrivacyResp);
      const result: TermsAndPrivacyResultInterface = {
        isSuccess: termsAndPrivacyResp.isSuccess,
        TermsAndPrivacy: termsAndPrivacy,
        status: termsAndPrivacyResp.status,
        message: termsAndPrivacyResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: TermsAndPrivacyResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const privacy = async (
  params: TermsAndPrivacyParams
): Promise<TermsAndPrivacyResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/privacy/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const termsAndPrivacyResp = res as RespTermsAndPrivacyModel;
      const termsAndPrivacy = setTermsAndPrivacyModel(termsAndPrivacyResp);
      const result: TermsAndPrivacyResultInterface = {
        isSuccess: termsAndPrivacyResp.isSuccess,
        TermsAndPrivacy: termsAndPrivacy,
        status: termsAndPrivacyResp.status,
        message: termsAndPrivacyResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: TermsAndPrivacyResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getTermsAndPrivacyParams = (params: TermsAndPrivacyParams) => {
  return {
    network: params.network,
  };
};

const setTermsAndPrivacyModel = (payload: RespTermsAndPrivacyModel) => {
  // The backend can return an empty result (no Terms/Privacy configured yet), in
  // which case result[0] is undefined. Guard so we return empty content instead
  // of throwing a TypeError that surfaced as a broken/looping modal.
  const first = payload?.result?.[0];
  const TermsAndPrivacy = {
    version: first?.version ?? "",
    content: first?.content ?? "",
  };
  return TermsAndPrivacy;
};

const handleErrorResponse = () => {};

export const termsAndPrivacyService = {
  terms,
  privacy,
  getTermsAndPrivacyParams,
  handleErrorResponse,
  setTermsAndPrivacyModel,
};
